import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgThermostaatHoger = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15"
    />
    <path
      fill="#85E3F9"
      d="M20 32.5c6.904 0 12.5-5.596 12.5-12.5S26.904 7.5 20 7.5 7.5 13.096 7.5 20 13.096 32.5 20 32.5"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M23.578 7.58a12.98 12.98 0 0 1 7.718 6.094l-.871.492a11.98 11.98 0 0 0-7.123-5.625z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="m17.18 21.89-2.68 4.24-2.68-4.24zm1.82-1h-9L14.5 28zM10 19.11 14.5 12l4.5 7.11z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m12.727 13.363.846.534-2.285 3.613h1.862v1H9.472z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M28.79 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1.39 0a.398.398 0 0 0-.395-.463.4.4 0 0 0-.395.463.4.4 0 1 0 .79 0"
    />
    <path
      fill="#00C5F2"
      d="M28.79 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1.39 0a.398.398 0 0 0-.395-.463.4.4 0 0 0-.395.463.4.4 0 1 0 .79 0M22.6 19.18l-1 .61-.6-.94 1.72-1.36h1.2v4.76H22.6zM24.71 21.8l.43-.89c.35.217.758.325 1.17.31.47 0 .88-.16.88-.59 0-.25-.24-.48-.76-.48a1.2 1.2 0 0 0-.66.16l-.34-.65 1.3-1H25v-1.17h3.22v1.12l-.94.81q.19.017.37.08a1.23 1.23 0 0 1 .85 1.22c0 1.14-1 1.6-2.07 1.6a2.9 2.9 0 0 1-1.72-.52"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgThermostaatHoger);

export default ForwardRef;
